<template>
  <div class="container">
    <div class="title">
      Prime Weekly
    </div>

    <div class="package">
      <span class="most-popular">
        MOST POPULAR
      </span>
      <div class="discount">
        30% cheaper
      </div>
      <h2>1,000</h2>
      <p>Renews every 7 days</p>
      <p class="old-price">
        ₺154,00
      </p>
      <p class="price">
        ₺99,99
      </p>
    </div>

    <div class="package">
      <span class="best-deal">
        BEST DEAL
      </span>
      <div class="discount">
        35% cheaper
      </div>
      <h2>
        5,000
      </h2>
      <p>
        Renews every 30 days
      </p>
      <p class="old-price">
        ₺569,00
      </p>
      <p class="price">
        ₺369,99
      </p>
    </div>

    <button class="subscribe-btn">
      Subscribe now
    </button>
  </div>
</template>

<script>
export default {
  name: 'Paywall',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  font-family: Arial, sans-serif;
  background: #000;
  color: #fff;
  text-align: center;
  margin: 0;
  padding: 20px;
}
.container {
  max-width: 400px;
  margin: auto;
  background: #111;
  padding: 20px;
  border-radius: 10px;
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.package {
  background: #222;
  padding: 15px;
  border-radius: 10px;
  margin: 15px 0;
  position: relative;
}
.discount {
  color: #00ff00;
  font-size: 14px;
  font-weight: bold;
}
.most-popular, .best-deal {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #ff00ff;
  color: #fff;
  padding: 5px 10px;
  border-radius: 10px;
  font-size: 12px;
}
.price {
  font-size: 22px;
  font-weight: bold;
}
.old-price {
  text-decoration: line-through;
  color: gray;
  font-size: 18px;
}
.subscribe-btn {
  display: block;
  width: 100%;
  background: linear-gradient(to right, #00ff99, #ff00ff);
  color: white;
  padding: 15px;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin-top: 20px;
}
</style>
